import Card from '@mui/material/Card'
import CardActionArea from '@mui/material/CardActionArea'
import Stack from '@mui/material/Stack'
import { alpha, useTheme } from '@mui/material'

import { ChevronRight } from '@mxenabled/mx-icons'
import { Text } from '@mxenabled/mxui'

import { useGlobalCopyStore } from '../../common'
import { DATE_FORMATS_INTL, formatDate } from '../../core/constants'
import { RecurrenceStatus } from '../../core'
import { BeatMaterialIcon } from '../../microinsights'

interface UpcomingRecurrenceCardProps {
  expectedDate: Date
  onMarkAsPaidClick: () => void
  status?: RecurrenceStatus
}

export const UpcomingRecurrenceCard = ({
  expectedDate,
  onMarkAsPaidClick,
  status,
}: UpcomingRecurrenceCardProps) => {
  const theme = useTheme()
  const { recurring: copy } = useGlobalCopyStore()

  const isPaid = status === RecurrenceStatus.Paid

  return (
    <Card variant="elevation">
      <CardActionArea onClick={onMarkAsPaidClick}>
        <Stack
          alignItems="center"
          direction="row"
          justifyContent="space-between"
          sx={{ px: 16, py: 14 }}
        >
          <Stack alignItems="center" direction="row" gap={12}>
            <BeatMaterialIcon
              bgColor={alpha(theme.palette.primary.main, 0.15)}
              name={isPaid ? 'check_circle' : 'calendar_clock'}
            />
            <Stack direction="column">
              <Text fontSize={11} variant="body1">
                {isPaid ? copy.paid : copy.upcoming}
              </Text>
              <Text bold={true} variant="body1">
                {formatDate(expectedDate, DATE_FORMATS_INTL.MONTH_DAY_YEAR)}
              </Text>
            </Stack>
          </Stack>

          <Stack alignItems="center" direction="row" gap={4}>
            <Text bold={true} variant="body1">
              {isPaid ? copy.mark_as_unpaid_cta : copy.mark_as_paid_cta}
            </Text>
            <ChevronRight size={20} />
          </Stack>
        </Stack>
      </CardActionArea>
    </Card>
  )
}
